import categoryB1Image from '../assets/images/category(b,1).png';
import category22mImage from '../assets/images/category(2,2m).png';
import category3Image from '../assets/images/category(3).png';
import category4Image from '../assets/images/category(4).png';

export const roleTypes = {
  1: 'admin',
  2: 'general',
  3: 'facilitator'
};

export const roleTypesEnum = [
  { id: 1, name: 'Admin' },
  { id: 2, name: 'General' },
  { id: 3, name: 'Facilitator' },
];

export const roleIds = {
  admin: 1,
  general: 2,
  facilitator:3
};

export const riskAssessmentAccessTypes = {
  RESTRICTED: 'restricted',
  UNRESTRICTED: 'unrestricted',
  NORMAL: 'normal',
};
export const riskAssessmentAccessIds = {
  restricted: 1,
  unrestricted: 3,
  normal: 2,
};
export const riskAssessmentAccessNames = {
  1: 'restricted',
  3: 'unrestricted',
  2: 'normal',
};

export const assessmentTypeIds = {
  riskAssessment: 1,
  functionalSafety: 2,
  cybersecurity: 3,
};

export const assessmentTypeNames = {
  1: 'Risk Assessment',
  2: 'Functional Safety',
  3: 'Cybersecurity Assessment',
};

export const taskFrequencyEnum = [
  { id: 1, name: 'Many times per shift' },
  { id: 2, name: 'Every shift' },
  { id: 3, name: 'Weekly' },
  { id: 4, name: 'Monthly' },
  { id: 5, name: 'Quarterly' },
  { id: 6, name: 'Annually' },
  { id: 7, name: 'Between 1 to 5 years' },
  { id: 8, name: 'Greater than 5 years' },
];

export const EventStatusEnum = [
  { label: 'Not Started', value: 4, color: '#808080' },
  { label: 'In Progress', value: 5, color: '#007BFF' },
  { label: 'Completed', value: 1, color: '#28A745' },
  { label: 'Removed', value: 2, color: '#DC3545' },
];

export const ActionRequiredEnum = [
  { label: 'Product management', value: 1 },
  { label: 'Engineering', value: 2 },
  { label: 'Product support', value: 3 },
  { label: 'Publications', value: 4 },
  { label: 'Training', value: 5 },
  { label: 'Other', value: 6 },
];

export const EventStatusIds = {
  NotStarted: 4,
  InProgress: 5,
  COMPLETED: 1,
};

/** Aligns API / list values with EventStatusEnum so MUI Select always matches a MenuItem. */
export function parseEventStatusForForm(raw) {
  const allowed = new Set(EventStatusEnum.map(o => o.value));
  if (raw == null || raw === '') {
    return EventStatusIds.NotStarted;
  }
  const n = Number(raw);
  if (Number.isNaN(n) || !allowed.has(n)) {
    return EventStatusIds.NotStarted;
  }
  return n;
}

export const lifeCyclePhasesEnum = [
  { id: 1, name: 'Manufacturing' },
  { id: 2, name: 'Transport' },
  { id: 3, name: 'Storage' },
  { id: 4, name: 'Commissioning' },
  { id: 5, name: 'Setting' },
  { id: 6, name: 'Operation' },
  { id: 7, name: 'Maintenance' },
  { id: 8, name: 'Troubleshooting' },
  { id: 9, name: 'Dismantling' },
];

export const getUserRoleName = roleId => {
  return roleTypes[roleId];
};

export const userStatusTypes = {
  1: 'pending',
  2: 'approved',
  3: 'declined',
};

export const userStatusEnum = [
  { id: 1, name: 'Pending' },
  { id:2, name: 'Approved' },
  { id: 3, name: 'Declined' },

];

export const userStatusIds = {
   'pending':1,
  'approved':2,
 'declined': 3,
};

export const getUserStatus = statusId => {
  return userStatusTypes[statusId];
};

export const rbac = {
  riskAssessmentMoreActions: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    } else if (roleId === 2) {
      return false;
    }
  },
  addEditProductLineModels: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    } else if (roleId === 2) {
      return false;
    }
  },
  addEditProductLine: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    } else if (roleId === 2) {
      return false;
    }
  },
  newRiskAssessment: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    } else if (roleId === 2) {
      return false;
    }
  },
  addnewMachine: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    } else if (roleId === 2) {
      return false;
    }
  },
  addTask: roleId => {
    if (roleId === 1 || roleId === 3) {
      return true;
    
    } else if (roleId === 2) {
      return false;
    }
  },
  deleteRiskAssessment: roleId => {
    if (roleId === 3) {
      return true;
    } else {
      return false
    }
  }
};

export const sideBarTabsNoAccess = {
  1: [],
  2: [
    'userlist',
    'role',
    'productLineAccess',
    'restrictedRiskAssessments',
    'deleted',
  ],
  3: ['userlist',
      'deleted'
  ]
};

export const likelihoodUnwantedEventEnum = [
  // { id: 1, name: "N/A" },
  { id: 2, name: 'Rare' },
  { id: 3, name: 'Unlikely' },
  { id: 4, name: 'Possible' },
  { id: 5, name: 'Likely' },
  { id: 6, name: 'Almost Certain' },
];

export const severityUnwantedEventEnum = [
  { id: 1, name: 'Minor' },
  { id: 2, name: 'Medium' },
  { id: 3, name: 'Serious' },
  { id: 4, name: 'Major' },
  { id: 5, name: 'Catastrophic' },
];

export const taskStatusIDS = {
  inProgress: 1,
  notStarted: 3,
  completed: 2,
  needsReview: 4,
};

export const taskStatusEnum = [
  { id: 3, name: 'Not Started' },
  { id: 1, name: 'In Progress' },
  { id: 2, name: 'Completed' },
  { id: 4, name: 'Needs Review' },
];

export const riskAssessmentStatusTypes = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  NEEDS_REVIEW: 'needs_review',
};

export const riskAssessmentStatusId = {
  in_progress: 1,
  completed: 2,
  not_started: 3,
  needs_review: 4,
};
export const riskAssessmentStatusNames = {
  1: 'in_progress',
  2: 'completed',
  3: 'not_started',
  4: 'needs_review',
};
export const enumStatusId = {
  Critical: 1,
  High: 2,
  Moderate: 3,
  Low: 4,
};

export const statusEnum = [
  { id: 1, name: 'Critical' },
  { id: 2, name: 'High' },
  { id: 3, name: 'Moderate' },
  { id: 4, name: 'Low' },
];

export const sortingEnum = [
  {id: 'name', name: 'Task Name'},
  {id: 'details', name: 'Task Details'},
  {id: 'life_cycle_phase', name: 'Life Cycle Phase'},
  {id: 'task_sub_categories', name: 'Task Subcategory'},
  {id: 'frequency', name: 'Task Frequency'},
  {id: 'status', name: 'Status'},
];

export const sortingFunctionalSafetyEnum = [
  {id: 'name', name: 'Functional Safety Name'},
  {id: 'details', name: 'Functional Safety Details'},
  {id: 'status', name: 'Status'},
];

export const statusTypes = {
  1: 'Critical',
  2: 'High',
  3: 'Moderate',
  4: 'Low',
};

export const getStatus = status => {
  return statusTypes[status];
};

export const personellExposedId = {
  OPERATOR: 21,
  MAINTENACE: 22,
  TRAINEES: 23,
  GENERAL_PUBLIC: 24,
};

export const personellExposedNames = {
  21: 'OPERATOR',
  22: 'MAINTENACE',
  23: 'TRAINEES',
  24: 'GENERAL_PUBLIC',
};
export const personellExposedFullNames = {
  OPERATOR: 'Operator',
  MAINTENACE: 'Maintenance personnel or technicians',
  TRAINEES: 'Trainees and apprentices',
  GENERAL_PUBLIC: 'General Public',
};

export const LimitTypesId = {
  SPACE: 1,
  USE: 2,
  TIME: 3,
  OTHER: 4,
};
export const LimitTypesNames = {
  1: 'SPACE',
  2: 'USE',
  3: 'TIME',
  4: 'OTHER',
};
export const LimitTypesIds = {
  SPACE: 1,
  USE: 2,
  TIME: 3,
  OTHER: 4,
};

export const accountForId = {
  RANGE_MOVEMENT: 11,
  SPACE_REQUIREMENT: 12,
  HUMAN_INTERACTION: 13,
  MACHINE_POWER: 14,
  DIFFERENT_MACHINE: 21,
  USE_OF_MACHINERY: 22,
  LIFE_LIMIT: 31,
  RECOMMENTDED_SERVICE: 32,
  PROPERTIES_MATERIAL: 41,
  HOUSE_KEEPING: 42,
  ENVIRONMENTAL: 43,
};

export const sortingEnumForPue = [
  { id: '4', name: 'Not Started' },
  { id: '5', name: 'In Progress' },
  { id: '1', name: 'Completed' },
  { id: '2', name: 'Removed' },
  { id: 'all', name: 'All' },
];

export const accountForNames = {
  11: 'RANGE_MOVEMENT',
  12: 'SPACE_REQUIREMENT',
  13: 'HUMAN_INTERACTION',
  14: 'MACHINE_POWER',
  21: 'DIFFERENT_MACHINE',
  22: 'USE_OF_MACHINERY',
  31: 'LIFE_LIMIT',
  32: 'RECOMMENTDED_SERVICE',
  41: 'PROPERTIES_MATERIAL',
  42: 'HOUSE_KEEPING',
  43: 'ENVIRONMENTAL',
};
export const accountForFullNames = {
  RANGE_MOVEMENT: 'The range of movement',
  SPACE_REQUIREMENT:
    'Space requirements for persons interacting with the machine, such as during operation and maintenance',
  HUMAN_INTERACTION: 'Human interaction such as the operator-machine interface',
  MACHINE_POWER: 'The machine-power supply interface',
  DIFFERENT_MACHINE:
    'Different Machine operating modes and different intervention procedures for the users, including interventions required by malfunctions of the machine',
  USE_OF_MACHINERY:
    'The use of the machinery (for example, industrial, non-industrial and domestic) by persons identified by sex, age, dominant hand usage, or limiting physical abilities (visual or hearing impairment, size, strength, etc.)',
  LIFE_LIMIT:
    'The life limit of the machinery and/or of some of its components',
  RECOMMENTDED_SERVICE: 'Recommended service intervals',
  PROPERTIES_MATERIAL: 'Properties of the materials) to be processed',
  HOUSE_KEEPING: 'Housekeeping - the level of cleanliness required',
  ENVIRONMENTAL:
    'Environmental the recommended minimum and maximum temperatures, whether the machine can be operated indoors or outdoors. in dry or wet weather, in direct sunlight, tolerance to dust and wet, etc.',
};

export const eventRowInfoIconEnum = {
  1: '1. Fall from height\n\n1.1. Injury during access to equipment and its routine service and inspection points, work platforms and operator workstation due to poor location of service and inspection points, lack of fall from height protection, slippery surfaces,accumulation of dirt or other material, or poorly lit environment\n\n1.2. Injury from falls caused by using chains as part of the handrail or ladder opening protection\n\n1.3. Injury due to inappropriate access and/or egress',
  2: '2. Fall on same level\n\n2.1. Injury during access to equipment and its routine service and inspection points, work platforms and operator workstation due to poor location of service and inspection points, lack of fall from height protection, slippery surfaces,accumulation of dirt or other material, or poorly lit environment\n\n2.2. Injury resulting from slips, trips and falls due to uneven work surfaces or platforms',
  3: '3. Egress blocked during emergency\n\n3.1. Harm due to entrapment or obstruction should normal access be blocked by fire (including tire heating) ormachine damage,\n\n3.2. Harm from entrapment in the cabin due to fire blocking emergency egress\n\n3.3. Entrapment due to lack of alternate route of egress in an emergency',
  4: '4. Struck by or contact with materials, substances\n\n4.1. Harm from materials falling off platforms on to persons below\n\n4.2. Injury caused by fasteners, brackets hoses, and fittings that protrude into the walkways and work areas\n\n4.3. Harm due to uncontrolled release of pressure from the tire and rim assembly during operation and maintenancedue to:\n\n4.3.1. Overly complicated rim assembly systems that drive unwanted behaviours such as:\n\n4.3.1.1. Failure to remove pressure from tires\n\n4.3.1.2. Failure to follow the correct procedure or sequence when attempting to maintain or remove them\n\n4.3.2. Inter-reliance of components\n\n4.4. Harm from exposure to energies such as heat; electricity; radiation; compressed air; high pressure fluids,including hydraulic fluids; and falling objects\n\n4.5. Friction burns, injection or other harm due to working in close proximity to hydraulic equipment or systems\n\n4.6. Scalding or burning from exposure to accessible hot surfaces including but not limited to, engines, hot exhaust, engine components, cooling systems and hydraulic components\n\n4.7. Electrocution or burning from contact with electrical switches, wires or devices\n\n4.8. Harm from exposure to:\n\n4.8.1. Energy induced in hydraulic systems from cylinders\n\n4.8.2. Energy inadvertently released by secondary systems e.g. fire systems, air bags.\n\n4.8.3. Residual energy retained after isolation and apparent de-energisation e.g. in springs, ropes, conveyor systems, accumulators, receiver tanks and fire systems\n\n4.8.4. Energy released from pressure vessels that have not been safely depressurised, including prematureremoval of radiator caps\n\n4.9. Harm from exposure to high pressure fluids as a result of failure of components, hoses, pipes or fittings due to:\n\n4.9.1. Corrosion\n\n4.9.2. Excessive pressure build-up\n\n4.9.3. Damage (e.g. from fallen material)\n\n4.10. Injury to personnel, either during normal operation or in the event of a roll over or other accident, from inhalation, ingestion, skin abrasion, slips, trips or other mechanism due to:\n\n4.10.1. FSS components which are poorly located 4.10.2. Accidental actuation of the FSS\n\n4.11. Injury due to workstation design & external structures, including:\n\n4.11.1. Protruding structures\n\n4.11.2. Sharp edges\n\n4.11.3. Structures not adequately fixed to equipment\n\n4.11.4. Roll over protection structures (ROPS)\n\n4.11.5. Intrusion into the cab by other equipment, such as the tray of another haul truck\n\n4.12. Injury occurring during operation and maintenance tasks (e.g. falling material, handling liquids, machine consumables and spillage) due to no/inadequate design for these activities\n\n4.13. Burns from contact with hydraulic hoses or piping within confined space ',
  5: '5. Caught between moving objects\n\n5.1. Crush injury during maintenance activities due to:\n\n5.1.1. Physical size of the wheels\n\n5.1.2. Need to have people working inside the arms of tire manipulators\n\n5.1.3. Impractical and inaccessible jacking points\n\n5.2. Entanglement in rotating parts including engine fans; pulleys; drive belts; gears; drive drums; rollers; and rotating shafts, including drill rods and steels\n\n5.3. Injury from being struck by a release of poorly secured moving or rotating equipment or components\n\n5.4. Entrapment, entanglement, and/or crushing from moving equipment such as: arms, jaws, gates, doors, pull down ropes/chains, winches and foot clamps\n\n5.5. Crush injury occurring during operation and maintenance tasks due to poorly designed crush and pinch point locations\n\n5.6. Injury due to use of inappropriate tools for manual tasks associated with installing, operating and maintaining the equipment\n\n5.7. Injury during handling of equipment components due to:\n\n5.7.1. Excessive weight and/or\n\n5.7.2. lack of suitable lifting points or hand holds combined with awkward positioning',
  6: '6. Collisions\n\n6.1. Harm from impaired visibility (including distorted or degraded vision) or impaired awareness of hazards in a variety of operating conditions due to:\n\n6.1.1. Inadequate lighting for headlights, tail, reversing, turn, brake, strobe, flashing lights, etc.\n\n6.1.2. Inadequately lit inspection areas\n\n6.1.3. Lack of fit for purpose receptacles for light fittings that suit standard & alternative lights\n\n6.1.4. devices (mirrors, cameras, windscreen wipers and washers etc.) that are not fit for purpose\n\n6.2. Harm from restricted or impeded operator vision of the surrounding environment and for tool operation, due to:\n\n6.2.1. Cab layout, location of windows and external structures (catwalks, handrails, protective structures, line of site mirrors, etc.) \n\n6.2.2. Poorly located or designed internal attachments, such as screens, hardware, equipment displays, sun blinds, etc. \n\n6.3. Harm from collisions due to persons and small vehicles being encouraged/forced, by the equipment design, to locate on the operator’s blind side \n\n6.4. Harm due to difficult access to communication systems, such as no two-way radio provision in cabin',
  7: '7. Loss of machine stability\n\n7.1. Harm from loss of machine stability while operating, tramming, articulating or relocating due to:\n\n7.1.1. Inappropriate gear selection or over speed conditions on a grade 7.1.2. Working outside limits of lifting capacity and operating radius\n\n7.1.3. Incorrect load placement or overloading, which may cause loss of steering control\n\n7.1.4. Failure of stability devices e.g. outriggers\n\n7.1.5. Failure to warn operator when design limits are being exceeded',
  8: '8. Wheel assembly, rim or tire failure, explosion\n\n8.1. Harm due to uncontrolled release of pressure from the tire and rim assembly during operation and maintenance due to:\n\n8.1.1. Overly complicated rim assembly systems that drive unwanted behaviours such as:\n\n8.1.1.1. Failure to remove pressure from tires\n\n8.1.1.2. Failure to follow the correct procedure or sequence when attempting to maintain or remove them\n\n8.1.2. Inter-reliance of components\n\n8.2. Harm due to abnormal rim condition that becomes evident only when the rim fastening system is released\n\n8.3. Harm due to assembly failure from mismatched components on multiple component rim assemblies\n\n8.4. Harm from pyrolysis/explosion of the tire and rim assembly due to e.g. improperly fitted tire/rim under correct inflation pressure\n\n8.5. Harm due to:\n\n8.5.1. Wheel nuts falling off\n\n8.5.2. Stud failure due to over-torque\n\n8.5.3. Failure to re-torque sometime after fitment\n\n8.6. Harm due to tire or rim failure occurring because there is no provision for repair history or previous duty to be linked to individual tires and rims',
  9: '9. Extreme temperature exposure\n\n9.1. Harm from exposure to extreme temperatures\n\n9.2. Harm from excessive heat due to lack of adequate ventilation or proximity to heat radiating components',
  10: '10. Fire\n\n10.1. Harm from fire arising from damage (including heating, melting and chaffing) to electrical cables and components; hydraulic hoses; and fuel lines due to design inadequacies, including:\n\n10.1.1. Poor location\n\n10.1.2. Inadequate segregation of fuel and ignition sources\n\n10.1.3. Flaws in clamping or restraints\n\n10.2. Harm from fire arising from heat generated by surface frictions (including tires)\n\n10.3. Harm from fire igniting in, or being propagated by, the build-up of combustible material e.g. dirt, oily rags\n\n10.4. Harm from entry into hazard zones due to the location of isolation points\n\n10.5. Injury to personnel, either during normal operation or in the event of a roll over or other accident, from inhalation, ingestion, skin abrasion, slips, trips or other mechanism due to:\n\n10.5.1. FSS components which are poorly located\n\n10.5.2. Accidental actuation of the FSS\n\n10.6. Harm from excessive/uncontrolled spread of fire, due to:\n\n10.6.1. Lack of automatic engine shutdown and/or isolation of fuel sources\n\n10.6.2. Inactivation of FSS due to the effects of fire and/or other damage\n\n10.6.3. Delayed activation of FSS due to difficult access to FSS controls\n\n10.6.4. Reduced effectiveness of FSS as a result of OEM fitted options, such as noise suppression blankets',
  11: '11. Respirable dust exposure\n\n11.1. Harm from exposure to respirable dust within the operating workspace due to:\n\n11.1.1. Inadequate or no climate control 11.1.2. Inadequate attenuation and restraint systems\n\n11.1.3. Open windows/doors\n\n11.1.4. Inadequate window/door seals\n\n11.2. Harm from inadvertent exposure to health hazards, including:\n\n11.2.1. Respirable dust',
  12: '12. Exposure to DPMs or other particulates\n\n12.1. Harm from exposure to DPCM and other particulates within the operating workspace due to:\n\n12.1.1. Inadequate or no climate control\n\n12.1.2. Inadequate attenuation and restraint systems\n\n12.1.3. Open windows/doors\n\n12.1.4. Inadequate window/door seals\n\n12.2. Harm from inadvertent exposure to health hazards, including:\n\n12.2.1. DPCM or particulate hazards\n\n12.2.2. Fibres in brake and other lining materials',
  13: '13. Exposure to irrespirable atmosphere in confined space\n\n13.1. Asphyxiation from irrespirable atmosphere due to lack of adequate ventilation\n\n13.2. Injury or illness from fire or chemical hazards due to the routing of hosing or piping within confined space\n\n13.3. Harm due to engulfment from materials or inundation by gas or liquids\n\n13.4. Harm due to rescue difficulties associated with difficult or minimal access',
  14: '14. Exposure to hazardous manual tasks\n\n14.1. Strain and sprains during maintenance activities\n\n14.2. Musculoskeletal or crush injury caused by mounting and dismounting of spare tires from storage or carriers\n\n14.3. Musculoskeletal injury or illness due to workstation design, including seat and seatbelt design, openings and cab height that promotes biomechanically compromised postures for the 5th percentile female to 95th percentile male body dimensions including:\n\n14.3.1. Inappropriate or compromised head / neck posture due to restricted visibility and/or control and display positioning\n\n14.3.2. Inappropriate or compromised hand/wrist posture due to mechanism required to manipulate/grasp control\n\n14.3.3. Inappropriate or compromised shoulder and back posture due to extended reach to controls\n\n14.3.4. Excessive forces required to appropriately operate buttons, triggers, hand & foot controls, levers and other devices\n\n14.3.5. Inappropriate or compromised posture due to lack of adjustability of seat, pedals, steering wheel / controls, monitors/displays\n\n14.3.6. Postures arising from poor seat and belt design, resulting in improper operator utilization e.g.\n\n14.3.6.1. Inadequate lumbar support and adjustability\n\n14.3.6.2. Inadequate reduction of exposure to whole-body vibration\n\n14.4. Musculoskeletal injury from exposure to the following risk factors or combinations thereof:\n\n14.4.1. Forceful exertion\n\n14.4.2. Awkward or static posture\n\n14.4.3. Repetition or prolonged duration\n\n14.4.4. Hand arm &/or whole body vibration due to manual tasks associated with installing, operating and maintaining the equipment\n\n14.5. Injury during handling of equipment components due to:\n\n14.5.1. Excessive weight and/or \n\n14.5.2. lack of suitable lifting points or hand holds combined with awkward positioning\n\n14.6. Physical injury due to inadequate ergonomic design that restricts worker movement to perform work or access/egress',
  15: '15. Inadvertent or erroneous operation of a control\n\n15.1. Harm from exposure to harmful energy due to:\n\n15.1.1. Unintended activation of controls\n\n15.1.2. Failure to isolate and secure components with stored energy e.g. raised, slewed or articulated equipment\n\n15.2. Harm from incorrect use of equipment controls, incorrect/inaccurate calibration or ineffective maintenance due to poorly designed controls and displays, including:\n\n15.2.1. Lack of understanding or misunderstanding about function of the control or display\n\n15.2.2. counter-intuitive design and configuration\n\n15.2.3. Inconsistency in display or function in comparison with other controls or displays (within vehicle)\n\n15.2.4. Not appropriately considering simultaneous control operationn15.2.5. Ability for unintentional operation or selection\n\n15.2.6. Unexpected operating mode (mode errors)\n\n15.2.7. Frequently used and/or safety critical controls not being located within the zone of reach\n\n15.2.8. Insufficient clearance around controls and other workstation equipment',
  16: '16. Incorrect understanding of display or label\n\n16.1. Harm from misinterpretation of information due to displays or labels being:\n\n16.1.1. illegible\n\n16.1.2. incomprehensible\n\n16.1.3. not visible\n\n16.1.4. inappropriately located\n\n16.1.5. not using universal symbols or standardized terminology\n\n16.1.6. not durable',
  17: '17. Failure to respond to an alarm\n\n17.1. Harm, including mental overload, from warnings and alarms being overlooked, ignored or not heard due to these:\n\n17.1.1. not being seen/heard or understood\n\n17.1.2. not being reliable or sufficiently sensitive\n\n17.1.3. being over sensitive\n\n17.1.4. not fully integrated or interlocked with other warning systems\n\n17.1.5. being over-used, tampered with or compromised in any way e.g. being turned off',
  18: '18. Harm due to noise exposure\n\n18.1. Harm from exposure to excessive levels of noise\n\n18.2. Harm from noise levels that induce hearing loss, mental and/or physical fatigue for personnel in the workshop and other working environments due to maintenance activities associated with the equipment\n\n18.3. Harm caused by distraction and/or impaired ability to hear audible warnings or alarms (e.g. horns, directional reversing alarms) due to:\n\n18.3.1. Excessive and/or high impact noise levels generated by equipment\n\n18.3.2. Excessive levels of spectator noise penetrating the operator workspace',
  19: '19. Whole-body or peripheral vibration exposure\n\n19.1. Chronic health implications (e.g. musculoskeletal disorders (MSDs), white finger, hearing loss) from high frequency use of maintenance tooling\n\n19.2. Harm from exposure to excessive vibration and noise levels\n\n19.3. Harm from inadvertent exposure to excessive vibration due to operators not being aware of deterioration of equipment, such as un-captured machine degradation, design limits or conditions\n\n19.4. Acute or cumulative musculoskeletal injury, adverse health effects to body organs and increased levels of fatigue from excessive levels of whole-body vibration, especially in conjunction with sustained and/or awkward npostures, due to poor ergonomic design of equipment',
  20: '20. Failure of control system\n\n20.1. Injury due to failure of critical control systems, such as:\n\n20.1.1. Electronic systems\n\n20.1.2. Computer systems\n\n20.1.3. Equipment controls being damaged (bridging, abrasion, etc.) by respirable dust, DPCM and/or other particulates entering these systems',
  live_work:
    'Live Work: Any work on plant, equipment or system where the energy cannot be fully isolated in a practical manner, posing risk or injury due to uncontrolled energy within the hazard exposure zone.\n\nLive work clarification\n\nWork tasks where personnel are required to enter the articulation zone or operational shadow of un-isolated equipment.\n\nThe hazards associated with live work typically involve exposure to energy:\n\nUnintended Mechanical movement – e.g. mechanical linkage crush zones.\n\nLive Electrical work – e.g. fault finding energized conductors.\n\nPneumatic/Hydraulic Systems – e.g. pressurized hydraulic circuits and accumulators.\n\nStored Potential Energy – e.g. suspended loads.\n\nAny other type of energy that can activate a given item or piece of equipment, that requires isolation to ensure safety.',
};

export const eventDetailInfoIconEnum = {
  protective_measure: {
    inherently_safe_design_measure:
      'Inherently safe design measure: protective measure which either eliminates hazards or reduces the risks associated with hazards by changing the design or operating characteristics of the machine without the use of guards or protective devices ',
    safeguarding:
      'Safeguarding: protective measure using safeguards to protect persons from the hazards which cannot reasonably be eliminated or risks which cannot be sufficiently reduced by inherently safe design measures',
    information_for_use:
      'Information for use: protective measure consisting of communication links (for example, text, words, signs, signals, symbols, diagrams) used separately or in combination, to convey information to the user',
  },
  likelihood:
    'Rare: The event is not expected to ever occur during the life of the equipment (<1% chance/year)\n\n Unlikely: The event is expected to occur at some time during the life of the equipment (1-10% chance/year)\n\n Possible: The event occurs less than annually, but multiple times during the life of the equipment (11-50% chance/year)\n\n Likely: The event occurs once or twice a year (>50% chance/year-2x/year)\n\n Almost Certain: The event occurs more than twice a year (>2x/year)\n\nLikelihood considerations:\n\nExposure to the hazard\n\nOccurrence of the hazard\n\nPossibility to avoid or limit the hazard',
  worst_credible_severity:
    'Minor: Inconvenience, none or minor medical treatment.\n\n Medium: Reversible injuries, medical treatment of one person.\n\n Serious: Permanent injuries such as a loss of a limb or permanent paralysis that would prevent a normal lifestyle.\n\n Major: Single fatality \n\n Catastrophic: Multiple fatalities',
  internally_only:
    'Internally-only notes are notes that will be stored along with a risk assessment and will not be part of the final risk assessment export.  The use of these are up to the facilitator and could be used for future design improvement ideas that were captured as part of the risk assessment process or as an area to store action items.',
};

export const statusValues = {
  2: {
    1: getStatus(4),
    2: getStatus(4),
    3: getStatus(3),
    4: getStatus(2),
    5: getStatus(2),
  },
  3: {
    1: getStatus(4),
    2: getStatus(4),
    3: getStatus(3),
    4: getStatus(2),
    5: getStatus(1),
  },
  4: {
    1: getStatus(4),
    2: getStatus(3),
    3: getStatus(2),
    4: getStatus(1),
    5: getStatus(1),
  },
  5: {
    1: getStatus(3),
    2: getStatus(2),
    3: getStatus(2),
    4: getStatus(1),
    5: getStatus(1),
  },
  6: {
    1: getStatus(3),
    2: getStatus(2),
    3: getStatus(1),
    4: getStatus(1),
    5: getStatus(1),
  },
};

export const personExposedEnum = [
  {id: 1, name: 'Operator'},
  {id: 2, name: 'Bystander'},
  {id: 3, name: 'Co-worker'},
];


export const scoreParameterEnum = {
  severity: 1,
  exposure: 2,
  alternativeControls: 3,
  awarenessOfHazard: 4,
  abilityToReact: 5,
};

// Lookup tables
export const controllabilityMapping = {
  'AC0-AR0': 'C3',
  'AC0-AR1': 'C3',
  'AC0-AR2': 'C3',
  'AC0-AR3': 'C3',
  'AC1-AW0-AR0': 'C3',
  'AC1-AW0-AR1': 'C3',
  'AC1-AW0-AR2': 'C3',
  'AC1-AW0-AR3': 'C3',
  'AC1-AW1-AR0': 'C3',
  'AC1-AW1-AR1': 'C3',
  'AC1-AW1-AR2': 'C3',
  'AC1-AW1-AR3': 'C2',
  'AC1-AW2-AR0': 'C3',
  'AC1-AW2-AR1': 'C3',
  'AC1-AW2-AR2': 'C2',
  'AC1-AW2-AR3': 'C1',
  'AC1-AW3-AR0': 'C3',
  'AC1-AW3-AR1': 'C2',
  'AC1-AW3-AR2': 'C1',
  'AC1-AW3-AR3': 'C0',
};



export const riskLevelMapping = {
  'S0-C0': 'QM',
  'S0-C1': 'QM',
  'S0-C2': 'QM',
  'S0-C3': 'QM',
  'S1-E0-C0': 'QM',
  'S1-E0-C1': 'QM',
  'S1-E0-C2': 'QM',
  'S1-E0-C3': 'a',
  'S1-E1-C0': 'QM',
  'S1-E1-C1': 'QM',
  'S1-E1-C2': 'a',
  'S1-E1-C3': 'b',
  'S1-E2-C0': 'QM',
  'S1-E2-C1': 'a',
  'S1-E2-C2': 'b',
  'S1-E2-C3': 'c',
  'S2-E0-C0': 'QM',
  'S2-E0-C1': 'QM',
  'S2-E0-C2': 'a',
  'S2-E0-C3': 'b',
  'S2-E1-C0': 'QM',
  'S2-E1-C1': 'a',
  'S2-E1-C2': 'b',
  'S2-E1-C3': 'c',
  'S2-E2-C0': 'a',
  'S2-E2-C1': 'b',
  'S2-E2-C2': 'c',
  'S2-E2-C3': 'd',
  'S3-E0-C0': 'a',
  'S3-E0-C1': 'a',
  'S3-E0-C2': 'b',
  'S3-E0-C3': 'c',
  'S3-E1-C0': 'a',
  'S3-E1-C1': 'b',
  'S3-E1-C2': 'c',
  'S3-E1-C3': 'd',
  'S3-E2-C0': 'b',
  'S3-E2-C1': 'c',
  'S3-E2-C2': 'd',
  'S3-E2-C3': 'e',
};


export const severityEnum = [
  {id: 'S0', name: 'S0: No significant injuries, requires only first aid'},
  {
    id: 'S1',
    name: 'S1: Injuries, requires medical attention, total recovery, reversible injury with no loss in work capacity after recovery',
  },
  {id: 'S2', name: 'S2: Severe injury, permanent loss in work capacity'},
  {id: 'S3', name: 'S3: Fatality'},
];


export const exposureEnum = [
  {id: 'E0', name: 'E0: E < 1%'},
  {id: 'E1', name: 'E1: 1% ≤ E < 10%'},
  {id: 'E2', name: 'E2: E ≥ 10%'},
];

export const alternativeControlsEnum = [
  {id: 'AC0', name: 'AC0: No alternative controls or possible action'},
  {id: 'AC1', name: 'AC1: 1 or more alternative control or possible action'},
];

export const awarenessOfHazardEnum = [
  {id: 'AW3', name: 'AW3: High: Known before action of function'},
  {id: 'AW2', name: 'AW2: Medium: Known at action of function, all the time'},
  {id: 'AW1', name: 'AW1: Low: Known at action of function, some of the time'},
  {
    id: 'AW0',
    name: 'AW0: None: Not known at action of the function, e.g. a syetem one cannot see or one is not aware of operating with an uncommand action',
  },
];


export const abilityToReactEnum = [
  {
    id: 'AR3',
    name: 'AR3: Operator can react in time, natural response, operator has hand or foot on control, e.g. operator can steer around hazard when brakes fails',
  },
  {
    id: 'AR2',
    name: 'AR2: Operator can react in time, natural response, operator has to move hand or foot to operate, e.g. operator applies park break when brake fails',
  },
  {
    id: 'AR1',
    name: 'AR1: Operator can react in time, unnatural response, e.g. operator grounds implement when brakes fails',
  },
  {
    id: 'AR0',
    name: 'AR0: Regardless of if there is another system to respond with, the operator or system is unable to respond in time to avoid the hazard',
  },
];

export const scoreParameterTooltipEnum = {
  severity: 'S0: No injury, S1: Minor injury, S2: Serious injury, S3: Fatal injury',
  exposure: 'E0: E < 1%, E1: 1-10%, E2: > 10%',
  alternativeControls: 'AC0: No alternative controls, AC1: 1 or more alternative controls',
  awarenessOfHazard: 'AW3: High, AW2: Medium, AW1: Low, AW0: None',
  abilityToReact: 'AR3: Natural immediate reaction, AR2: Natural reaction with movement, AR1: Unnatural reaction, AR0: Unable to react',
};


export const FUNCTIONAL_SAFETY_CHANNEL_TYPES = Object.freeze({
  INPUT: 'input',
  LOGIC: 'logic',
  OUTPUT: 'output',
  TE: 'te',
  OTE: 'ote',
  INPUT2: 'input2',
  LOGIC2: 'logic2',
  OUTPUT2: 'output2',
});


export const FUNCTIONAL_SAFETY_CATEGORY = Object.freeze({
  CATEGORY_B: 'B',
  CATEGORY_1: '1',
  CATEGORY_2: '2',
  CATEGORY_2M: '2M',
  CATEGORY_3: '3',
  CATEGORY_4: '4',
});

export const MTTF_CATEGORY = Object.freeze({
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  NONE: "NONE",
});

export const getMTTFCategory = (score) => {
  if(score<3) return "MTTFD is insufficient.";
  if (score>=3 && score<10) return MTTF_CATEGORY.LOW;
  if (score>=10 && score<30) return MTTF_CATEGORY.MEDIUM;
  if (score>=30 && score<=100) return MTTF_CATEGORY.HIGH;
};

/**
 * Calculate final MTTFd when there are multiple channels
 * Formula: Final MTTFd = 2/3 * (mttfdc1 + mttfdc2 - 1/((1/mttfdc1) + (1/mttfdc2)))
 * Where:
 * - mttfdc1 = MTTFd of Channel 1 (should already be capped at 100)
 * - mttfdc2 = MTTFd of Channel 2 (should already be capped at 100)
 * 
 * Note: Each channel should be capped at 100 before calling this function.
 * The final result is also capped at 100 as a safety measure per ISO 13849.
 * 
 * @param {number} mttfdc1 - MTTFd of Channel 1 (must be > 0, should be <= 100)
 * @param {number} mttfdc2 - MTTFd of Channel 2 (must be > 0, should be <= 100)
 * @returns {number} - Final MTTFd value, capped at 100 years
 */
export const calculateMultiChannelMTTFd = (mttfdc1, mttfdc2) => {
  // Validate inputs
  if (!mttfdc1 || mttfdc1 <= 0 || !mttfdc2 || mttfdc2 <= 0) {
    return 0;
  }

  // Ensure inputs are capped at 100 (defensive programming)
  // Note: Inputs should already be capped, but we cap again here for safety
  const cappedMttfdc1 = Math.min(mttfdc1, 100.0);
  const cappedMttfdc2 = Math.min(mttfdc2, 100.0);

  // Calculate: 2/3 * (mttfdc1 + mttfdc2 - 1/((1/mttfdc1) + (1/mttfdc2)))
  const inverseSum = (1 / cappedMttfdc1) + (1 / cappedMttfdc2);
  const parallelMTTFd = 1 / inverseSum;
  const finalMTTFd = (2 / 3) * (cappedMttfdc1 + cappedMttfdc2 - parallelMTTFd);

  // Cap at 100 years as per ISO 13849 (safety measure)
  return Math.min(finalMTTFd, 100.0);
};

export const getDcavgCategory = (score) => {
  if (score<60) return MTTF_CATEGORY.NONE;
  if (score>=60 && score<90) return MTTF_CATEGORY.LOW;
  if (score>=90 && score<99) return MTTF_CATEGORY.MEDIUM;
  if (score>=99 ) return MTTF_CATEGORY.HIGH;
};

export const hsrToDcEquivalent = (hsrScore) => {
  if (hsrScore >= 50 && hsrScore <= 80) return 60;
  if (hsrScore > 80) return 90;
  return 0; // Default if HSR score is below 50
};

export const getCcfResult = (score) => {
  if (score >= 65) return "PASS";
  if (score < 65) return "FAIL";
  return "N/A";
};

/**
 * Check if the system meets MPLA (Machine Performance Level Achieved) criteria
 * @param {string} mttfCategory - MTTF category (LOW, MEDIUM, HIGH, or "MTTFD is insufficient.")
 * @param {string} dcavgCategory - DCavg category (NONE, LOW, MEDIUM, HIGH)
 * @param {string} ccfResult - CCF result (PASS, FAIL, N/A)
 * @param {string} category - System category (B, 1, 2, 2M, 3, 4)
 * @returns {object} - { meetsCriteria: boolean, details: { mttf: boolean, dc: boolean, ccf: boolean }, applicable: { dc: boolean, ccf: boolean } }
 */
export const checkMplaCriteria = (mttfCategory, dcavgCategory, ccfResult, category) => {
  const result = {
    meetsCriteria: false,
    details: {
      mttf: false,
      dc: false,
      ccf: false,
    },
    applicable: {
      dc: false,
      ccf: false,
    },
  };

  // Helper function to check if MTTF is >= LOW (i.e., LOW, MEDIUM, or HIGH)
  const isMttfAtLeastLow = (mttf) => {
    return mttf === MTTF_CATEGORY.LOW || 
           mttf === MTTF_CATEGORY.MEDIUM || 
           mttf === MTTF_CATEGORY.HIGH;
  };

  // Helper function to check if MTTF is LOW to MEDIUM (not HIGH)
  const isMttfLowToMedium = (mttf) => {
    return mttf === MTTF_CATEGORY.LOW || mttf === MTTF_CATEGORY.MEDIUM;
  };

  // Helper function to check if MTTF is LOW to HIGH (LOW, MEDIUM, or HIGH)
  const isMttfLowToHigh = (mttf) => {
    return isMttfAtLeastLow(mttf);
  };

  // Helper function to check if DC is >= LOW (i.e., LOW, MEDIUM, or HIGH)
  const isDcAtLeastLow = (dc) => {
    return dc === MTTF_CATEGORY.LOW || 
           dc === MTTF_CATEGORY.MEDIUM || 
           dc === MTTF_CATEGORY.HIGH;
  };

  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_B) {
    // Category B: MTTF LOW to MEDIUM, DC N/A, CCF N/A
    result.details.mttf = isMttfLowToMedium(mttfCategory);
    result.applicable.dc = false; // N/A - not applicable
    result.applicable.ccf = false; // N/A - not applicable
    result.details.dc = true; // N/A - not checked (always pass)
    result.details.ccf = true; // N/A - not checked (always pass)
    result.meetsCriteria = result.details.mttf;
  } 
  else if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_1) {
    // Category 1: MTTF HIGH, DC N/A, CCF N/A
    result.details.mttf = mttfCategory === MTTF_CATEGORY.HIGH;
    result.applicable.dc = false; // N/A - not applicable
    result.applicable.ccf = false; // N/A - not applicable
    result.details.dc = true; // N/A - not checked (always pass)
    result.details.ccf = true; // N/A - not checked (always pass)
    result.meetsCriteria = result.details.mttf;
  } 
  else if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2) {
    // Category 2: MTTF >= LOW, DC >= LOW, CCF PASS
    result.details.mttf = isMttfAtLeastLow(mttfCategory);
    result.applicable.dc = true; // Applicable
    result.applicable.ccf = true; // Applicable
    result.details.dc = isDcAtLeastLow(dcavgCategory); // Check if DC is at least low
    result.details.ccf = ccfResult === "PASS"; // Check if CCF passes
    result.meetsCriteria = result.details.mttf && result.details.dc && result.details.ccf;
  } 
  else if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) {
    // Category 2M: MTTF HIGH, DC >= LOW, CCF PASS
    result.details.mttf = mttfCategory === MTTF_CATEGORY.HIGH;
    result.applicable.dc = true; // Applicable
    result.applicable.ccf = true; // Applicable
    result.details.dc = isDcAtLeastLow(dcavgCategory);
    result.details.ccf = ccfResult === "PASS";
    result.meetsCriteria = result.details.mttf && result.details.dc && result.details.ccf;
  } 
  else if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_3) {
    // Category 3: MTTF LOW to HIGH, DC >= LOW, CCF PASS
    result.details.mttf = isMttfLowToHigh(mttfCategory);
    result.applicable.dc = true; // Applicable
    result.applicable.ccf = true; // Applicable
    result.details.dc = isDcAtLeastLow(dcavgCategory);
    result.details.ccf = ccfResult === "PASS";
    result.meetsCriteria = result.details.mttf && result.details.dc && result.details.ccf;
  } 
  else if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_4) {
    // Category 4: MTTF HIGH, DC HIGH, CCF PASS
    result.details.mttf = mttfCategory === MTTF_CATEGORY.HIGH;
    result.applicable.dc = true; // Applicable
    result.applicable.ccf = true; // Applicable
    result.details.dc = dcavgCategory === MTTF_CATEGORY.HIGH;
    result.details.ccf = ccfResult === "PASS";
    result.meetsCriteria = result.details.mttf && result.details.dc && result.details.ccf;
  }

  return result;
};

/**
 * Calculate MPLA (Machine Performance Level Achieved) based on Table 6 from ISO 13849
 * For HSR method, uses Table 2 (HSR to DC correlation)
 * This function determines the achieved Performance Level (a, b, c, d, e) based on:
 * - Category (B, 1, 2, 2M, 3, 4)
 * - DCavg category (NONE, LOW, MEDIUM, HIGH) or HSR score
 * - MTTFd category (LOW, MEDIUM, HIGH)
 * - Whether HSR method is used
 * 
 * @param {string} category - System category (B, 1, 2, 2M, 3, 4)
 * @param {string} dcavgCategory - DCavg category (NONE, LOW, MEDIUM, HIGH) or HSR equivalent
 * @param {string} mttfCategory - MTTFd category (LOW, MEDIUM, HIGH)
 * @param {boolean} isHsrMethod - Whether HSR method is being used
 * @param {number} hsrScore - HSR score (required if isHsrMethod is true)
 * @returns {string} - Performance Level achieved: 'a', 'b', 'c', 'd', 'e', or 'Not covered'
 */
export const calculateMPLA = (category, dcavgCategory, mttfCategory, isHsrMethod = false, hsrScore = 0) => {
  // Handle invalid MTTFd category
  if (!mttfCategory || mttfCategory === "MTTFD is insufficient." || mttfCategory === MTTF_CATEGORY.NONE) {
    return "Not covered";
  }

  // If HSR method is used, use Table 2 (HSR to DC correlation)
  if (isHsrMethod) {
    return calculateMPLAWithHSR(category, mttfCategory, hsrScore);
  }

  // Category B: DCavg = none
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_B) {
    if (mttfCategory === MTTF_CATEGORY.LOW) return "a";
    if (mttfCategory === MTTF_CATEGORY.MEDIUM) return "b";
    if (mttfCategory === MTTF_CATEGORY.HIGH) return "Not covered";
  }

  // Category 1: DCavg = none
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_1) {
    if (mttfCategory === MTTF_CATEGORY.HIGH) return "c";
    return "Not covered"; // Low or Medium not covered
  }

  // Category 2: Can have DCavg = low or medium
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2) {
    // Category 2 with DCavg = low
    if (dcavgCategory === MTTF_CATEGORY.LOW ) {
      if (mttfCategory === MTTF_CATEGORY.LOW) return "a";
      if (mttfCategory === MTTF_CATEGORY.MEDIUM) return "b";
      if (mttfCategory === MTTF_CATEGORY.HIGH) return "c";
    }
    // Category 2 with DCavg = medium
    if (dcavgCategory === MTTF_CATEGORY.MEDIUM) {
      if (mttfCategory === MTTF_CATEGORY.LOW) return "b";
      if (mttfCategory === MTTF_CATEGORY.MEDIUM) return "c";
      if (mttfCategory === MTTF_CATEGORY.HIGH) return "d";
    }
    return "Not covered";
  }

  // Category 2M: Similar to Category 2, but typically requires DCavg >= low
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) {
    // Category 2M requires HIGH MTTFd to meet criteria
    if (mttfCategory !== MTTF_CATEGORY.HIGH) {
      return "Not covered";
    }
    // Category 2M with DCavg = low
    if (dcavgCategory === MTTF_CATEGORY.LOW) {
      return "c"; // Only HIGH MTTFd possible
    }
    // Category 2M with DCavg = medium
    if (dcavgCategory === MTTF_CATEGORY.MEDIUM) {
      return "d"; // Only HIGH MTTFd possible
    }
    return "Not covered";
  }

  // Category 3: Can have DCavg = low or medium
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_3) {
    // Category 3 with DCavg = low
    if (dcavgCategory === MTTF_CATEGORY.LOW) {
      if (mttfCategory === MTTF_CATEGORY.LOW) return "b";
      if (mttfCategory === MTTF_CATEGORY.MEDIUM) return "c";
      if (mttfCategory === MTTF_CATEGORY.HIGH) return "d";
    }
    // Category 3 with DCavg = medium
    if (dcavgCategory === MTTF_CATEGORY.MEDIUM) {
      if (mttfCategory === MTTF_CATEGORY.LOW) return "c";
      if (mttfCategory === MTTF_CATEGORY.MEDIUM) return "d";
      if (mttfCategory === MTTF_CATEGORY.HIGH) return "d";
    }
    return "Not covered";
  }

  // Category 4: DCavg = high
  if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_4) {
    if (dcavgCategory === MTTF_CATEGORY.HIGH) {
      if (mttfCategory === MTTF_CATEGORY.HIGH) return "e";
    }
    return "Not covered"; // Low or Medium MTTFd not covered, or DCavg not high
  }

  return "Not covered";
};

/**
 * Calculate MPLA using HSR method based on Table 2 (HSR to DC correlation)
 * Table 2 shows specific mappings for HSR scores to MPLA
 * 
 * @param {string} category - System category (B, 1, 2M only for HSR)
 * @param {string} mttfCategory - MTTFd category (MEDIUM or HIGH only for HSR)
 * @param {number} hsrScore - HSR score (0-100)
 * @returns {string} - Performance Level achieved: 'a', 'b', 'c', 'd', or 'Not covered'
 */
const calculateMPLAWithHSR = (category, mttfCategory, hsrScore) => {
  // HSR method only applies to specific categories: B, 1, 2M
  if (category !== FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_B && 
      category !== FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_1 && 
      category !== FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) {
    return "Not covered";
  }

  // HSR method only applies to MTTFd = Medium or High
  if (mttfCategory !== MTTF_CATEGORY.MEDIUM && mttfCategory !== MTTF_CATEGORY.HIGH) {
    return "Not covered";
  }

  // Determine DC equivalent from HSR score
  // HSR 50-80% → DC equivalent 60% (LOW)
  // HSR >80% → DC equivalent 90% (MEDIUM)
  const isHighHSR = hsrScore > 80;
  const isMediumHSR = hsrScore >= 50 && hsrScore <= 80;

  if (!isMediumHSR && !isHighHSR) {
    return "Not covered"; // HSR score below 50
  }

  // MTTFd = Medium
  if (mttfCategory === MTTF_CATEGORY.MEDIUM) {
    if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_B) {
      // Category B with MTTFd = Medium: MPLA = b (for both HSR ranges)
      return "b";
    }
    if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) {
      // Category 2M with MTTFd = Medium:
      // HSR 50-80% (DC 60%) → MPLA = b
      // HSR >80% (DC 90%) → MPLA = c
      if (isMediumHSR) return "b";
      if (isHighHSR) return "c";
    }
  }

  // MTTFd = High
  if (mttfCategory === MTTF_CATEGORY.HIGH) {
    if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_1) {
      // Category 1 with MTTFd = High: MPLA = c (for both HSR ranges)
      return "c";
    }
    if (category === FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) {
      // Category 2M with MTTFd = High:
      // HSR 50-80% (DC 60%) → MPLA = c
      // HSR >80% (DC 90%) → MPLA = d
      if (isMediumHSR) return "c";
      if (isHighHSR) return "d";
    }
  }

  return "Not covered";
};


export const getMplaCategoryImage=(category)=>{
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_B) return categoryB1Image;
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_1) return categoryB1Image;
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2) return category22mImage;
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_2M) return category22mImage;
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_3) return category3Image;
  if(category===FUNCTIONAL_SAFETY_CATEGORY.CATEGORY_4) return category4Image;
  return "";
}

export const compareMPLaAndMPLr = (mpla, mplr) => {
  let mplPassFail = null;
  if (mpla && mplr && mpla !== "Not covered") {
    const plHierarchy = {
      'e': 6, 'd': 5, 'c': 4, 'b': 3, 'a': 2, 'QM': 1
    };
    const mplaValue = plHierarchy[mpla] || 0;
    const mplrValue = plHierarchy[mplr] || 0;

    mplPassFail = mplaValue >= mplrValue ? 'PASS' : 'FAIL';
  }


  return mplPassFail;
}


